/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

/* eslint-disable import/no-unresolved, import/default */

import addEntityTemplate from './../table/add-entity.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

import base64js from 'base64-js';
import {utf8Encode, utf8Decode} from './utf8-support';

export default angular.module('tektelic.utils', [])
    .factory('utils', Utils)
    .name;

/*@ngInject*/
function Utils($q, $translate) {

    const tokenChars = [..."ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"];

    var service = {
        tableConfigDefaults: tableConfigDefaults,
        parseException: parseException,
        stringToBase64: stringToBase64,
        base64toString: base64toString,
        generateRandomToken: generateRandomToken,
        guid: guid
    }

    return service;
    
    function tableConfigDefaults(tableConfig) {
        tableConfig.deleteEntityTitle = tableConfig.deleteEntityTitle ||
            (() => { return $translate.instant('entity-table.delete-entity-title'); });

        tableConfig.deleteEntityContent = tableConfig.deleteEntityContent ||
            (() => { return $translate.instant('entity-table.delete-entity-text'); });

        tableConfig.deleteEntitiesTitle = tableConfig.deleteEntitiesTitle ||
            ((count) => { return $translate.instant('entity-table.delete-entities-title', {count: count}, 'messageformat'); });

        tableConfig.deleteEntitiesContent = tableConfig.deleteEntitiesContent ||
            (() => { return $translate.instant('entity-table.delete-entities-text'); });

        tableConfig.actionCellDescriptors = tableConfig.actionCellDescriptors || [];
        tableConfig.groupActionDescriptors = tableConfig.groupActionDescriptors || [];

        tableConfig.addEnabled = tableConfig.addEnabled ||
            (() => { return true });

        tableConfig.deleteEnabled = tableConfig.deleteEnabled ||
            (() => { return true });

        tableConfig.entitiesDeleteEnabled = tableConfig.entitiesDeleteEnabled ||
            (() => { return true });
        tableConfig.detailsReadOnly = tableConfig.detailsReadOnly ||
            (() => { return false });

        tableConfig.loadEntities = tableConfig.loadEntities ||
            (() => { return $q.when([]) });

        tableConfig.loadEntity = tableConfig.loadEntity ||
            ((/*entityId*/) => { return $q.when() });

        tableConfig.deleteEntity = tableConfig.deleteEntity ||
            (() => { return $q.when() });

        tableConfig.saveEntity = tableConfig.saveEntity ||
            ((entity) => { return $q.when(entity) });

        tableConfig.addEntityController = tableConfig.addEntityController || 'AddEntityController';
        tableConfig.addEntityTemplateUrl = tableConfig.addEntityTemplateUrl || addEntityTemplate;

        tableConfig.onDestroy = tableConfig.onDestroy ||
            (() => {});

    }

    function parseException(exception, lineOffset) {
        var data = {};
        if (exception) {
            if (angular.isString(exception) || exception instanceof String) {
                data.message = exception;
            } else {
                if (exception.name) {
                    data.name = exception.name;
                } else {
                    data.name = 'UnknownError';
                }
                if (exception.message) {
                    data.message = exception.message;
                }
                if (exception.lineNumber) {
                    data.lineNumber = exception.lineNumber;
                    if (exception.columnNumber) {
                        data.columnNumber = exception.columnNumber;
                    }
                } else if (exception.stack) {
                    var lineInfoRegexp = /(.*<anonymous>):(\d*)(:)?(\d*)?/g;
                    var lineInfoGroups = lineInfoRegexp.exec(exception.stack);
                    if (lineInfoGroups != null && lineInfoGroups.length >= 3) {
                        if (angular.isUndefined(lineOffset)) {
                            lineOffset = -2;
                        }
                        data.lineNumber = Number(lineInfoGroups[2]) + lineOffset;
                        if (lineInfoGroups.length >= 5) {
                            data.columnNumber = lineInfoGroups[4];
                        }
                    }
                }
            }
        }
        return data;
    }

    function stringToBase64(value) {
        var encoded = utf8Encode(value);
        var b64Encoded = base64js.fromByteArray(encoded);
        return b64Encoded;
    }

    function base64toString(b64Encoded) {
        var encoded = base64js.toByteArray(b64Encoded);
        var value = utf8Decode(encoded);
        return value;
    }

    function generateRandomToken(tokenLength) {
        return [...Array(tokenLength)]
            .map(() => {
                var symbol = tokenChars[Math.random() * tokenChars.length | 0];
                return Math.random() > 0.5 ? symbol.toLowerCase() : symbol;
            })
            .join``;
    }

    function guid(separator) {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        if (angular.isUndefined(separator) || separator == null) {
            separator = '-';
        }
        return s4() + s4() + separator + s4() + separator + s4() + separator +
            s4() + separator + s4() + s4() + s4();
    }

}



// WEBPACK FOOTER //
// ./src/app/common/utils.service.js